module.exports = __webpack_public_path__ + "img/lens-167-plus-07.e7a8ce44.png";